import { 
    setCookie, 
    getCookie,
    removeCookie
  } from '@/utils/cookie'
  
import {
    setLocalStorage,
    getLocalStorage,
    removeLocalStorage
} from '@/utils/local-storage'

import moment from 'moment'

import {
    getApiUserInformation
} from "@/services/api/login"

const TOKEN_KEY = 'oiais_user_token'
const ACCOUNT_KEY = 'oiais_user_account'
const CURRENT_FUNCTION_KEY = 'oiais_current_function'

export const state = () =>({
    current_function: '', //目前使用功能
    access_token: '', //登入成功後的access_token
    user_info: {}, //使用者資訊
    is_logging_in: false, //控制登入行為
})

export const getters = {
    /*
        共用方法，用來讀取memory, cookie, localStorage上的指定key值，並回傳任一個有紀錄的值
        data: 對應到state中有紀錄的值
        key: cookie/localStorage中的key
        defaultValue: 預設值，為空字串或空物件
     */
    getDatabyKey(data,key,defaultValue){
        var value = data || getCookie(key) || getLocalStorage(key);
        if (value == null) value = defaultValue
        if (value != defaultValue){
            if (data == defaultValue){
                data = value
            }
        }
        return data
    },
    //紀錄登入者Token
    getUserToken(state){
        state.access_token = getters.getDatabyKey(state.access_token,TOKEN_KEY,'');
        return state.access_token
    },
    //紀錄使用者的帳號與權限
    getUserInformation(state){
        state.user_info = getters.getDatabyKey(state.user_info,ACCOUNT_KEY,{});
        return state.user_info;
    },
    //紀錄目前呼叫的功能
    getCurrentFunction(state){
        state.current_function = getters.getDatabyKey(state.current_function,CURRENT_FUNCTION_KEY,'');
        return state.current_function;
    },
    getIsLoggingIn: state => state.is_logging_in,
}

export const mutations = {
    /*
        共用方法，用來設定 cookie, localStorage上的指定key值
        key: cookie/localStorage中的key
        payload: 欲存入的值
     */
    setDataByKey(key, payload){
        //因為store在刷新頁面就會消失，因此把token放到Cookie
        const now = moment();
        const expiredAt = now.add(18, 'hours');
        setCookie({ 
            name: key, 
            value: payload, 
            expiredAt: expiredAt 
        });
        //把token放到LocalStorage
        setLocalStorage({
            name: key, 
            value: payload
        });
    },
    //登入成功後設定Token
    setAccessToken(state, payload){
        //設定token到store, 
        state.access_token = payload;
        mutations.setDataByKey(TOKEN_KEY,payload);
    },
    //設定user_info
    setUserInformation(state, payload){
        state.user_info = payload;
        mutations.setDataByKey(ACCOUNT_KEY,payload);
    },
    //設定目前呼叫的功能
    setCurrentFunction(state, payload){
        state.current_function = payload;
        mutations.setDataByKey(CURRENT_FUNCTION_KEY,payload);
    },
    setIsLoggingIn(state,payload){
        state.is_logging_in = payload;
    },
    removeDataByKey(key){
        removeCookie(key);
        removeLocalStorage(key);
    },
    removeAccessToken(state){
        state.access_token = '';
        mutations.removeDataByKey(TOKEN_KEY);
    },
    removeUser(state){
        state.user_info = {};
        mutations.removeDataByKey(ACCOUNT_KEY);
    },
    removeCurrentFunction(state){
        state.current_function = '';
        mutations.removeDataByKey(CURRENT_FUNCTION_KEY);
    }
}
export const actions = {
    async fetchUserInfo({commit},payload){
        var user = {};
        if (payload != '') {
            var res = await getApiUserInformation(payload);
            user = (res.data)? res.data: {};
        }
        // 在 actions 裡面，可以用 context.commit 來呼叫 mutations，
        // 也可以用 context.dispatch 來呼叫另外一個 actions。
        commit('setUserInformation', user);
    },
    async checkTokenExists({ getters }){
       return getters.getUserToken
    },
    //清空登入資訊
    deleteBrowserStorage({commit}){
        commit('removeCurrentFunction');
        commit('removeUser');
        commit('removeAccessToken');
    }
}